export const PAYMENT_BACKENDS = {
  SOGENACTIF: 'sogenactif',
  STRIPE_WIFIRST_AGORA: 'stripe_wifirst_agora',
  STRIPE_WIFIRST: 'stripe_wifirst',
}

export const DEFAULT_PAYMENT_BACKEND = PAYMENT_BACKENDS.SOGENACTIF
